import { loading, success, error } from 'State/actions';

export const fetchGeneric = (
  getDataType,
  loadingType,
  errorType,
  tableName,
  postData = null
) => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(loadingType, true));

    try {
      const response = postData
        ? await MPWWebApi.postGenericInsertUpdate(tableName, postData)
        : await MPWWebApi.getGeneric(tableName);

      dispatch(
        success(getDataType, {
          data: response.data.Data,
        })
      );
    } catch (ex) {
      dispatch(error(errorType, ex));
    }
    dispatch(loading(loadingType, false));
  };
};

export const postGenericFile = (
  resourceName,
  data,
  displayFileProgress = true
) => (dispatch, getState, MPWWebApi) =>
  MPWWebApi.postGenericFile(resourceName, data, dispatch, displayFileProgress);



// WEBPACK FOOTER //
// ./src/state/generic/actions.js